import { render, staticRenderFns } from "./AvailableOtherLaboursNtar.vue?vue&type=template&id=453ae710&scoped=true"
import script from "./AvailableOtherLaboursNtar.vue?vue&type=script&lang=js"
export * from "./AvailableOtherLaboursNtar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ae710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453ae710')) {
      api.createRecord('453ae710', component.options)
    } else {
      api.reload('453ae710', component.options)
    }
    module.hot.accept("./AvailableOtherLaboursNtar.vue?vue&type=template&id=453ae710&scoped=true", function () {
      api.rerender('453ae710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableOtherLaboursNtar.vue"
export default component.exports